// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `path[data-v-3f53254b],rect[data-v-3f53254b]{fill:currentColor}line[data-v-3f53254b]{stroke:currentColor}.name text[data-v-3f53254b]{text-anchor:end;font-size:2.4px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
